// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
export const ssoModeEnum = Object.freeze({
  AUTHENTICATION_ONLY: 'authentication-only',
  AUTHORIZATION: 'authorization'
})

export const dispositionEnum = Object.freeze({
  LEAST_SECURE: 'least-secure',
  MOST_SECURE: 'most-secure'
})

export const authorizationEnum = Object.freeze({
  LOCAL: 'Local',
  SAML: 'SAML'
})

export const ssoConnectionType = 'SSO connection'

export const protocolEnum = Object.freeze({
  SAML: 'SAML',
  OIDC: 'OIDC'
})

export const idpConfigOptions = Object.freeze({
  UPLOAD_FROM_FILE: 'Upload a metadata XML file',
  SPECIFY_URL: 'Specify a metadata URL',
  MANUAL: 'Manual entry of configuration details'
})

export const getAuthorizationText = (status) => {
  let text = ''
  switch (status) {
    case ssoModeEnum?.AUTHENTICATION_ONLY:
      text = authorizationEnum.LOCAL
      break
    case ssoModeEnum?.AUTHORIZATION:
      text = authorizationEnum.SAML
      break
    default:
      break
  }
  return text
}

export const getAuthentication = (value) => {
  let text = ''
  switch (value) {
    case 'Saml':
      text = 'SAML 2.0'
      return text
    case 'OIDC':
      text = 'OIDC'
      return text
    default:
      break
  }
  return text
}

export const idp = Object.freeze({
  entityIdUrl: 'https://sso.common.cloud.hpe.com',
  acsUrl: 'https://sso.common.cloud.hpe.com/sp/ACS.saml2',
  defaultRelayStateUrl: 'https://common.cloud.hpe.com'
})

export const ssoConfigurationsSortEnum = Object.freeze({
  NAME_ASC: 'name asc'
})
